export const DrawerController = {
  show: () => {},
  hide: () => {},
}

export const registerDrawer = (showFn, hideFn) => {
  DrawerController.show = showFn
  DrawerController.hide = hideFn
}
